import { render, staticRenderFns } from "./classRight.vue?vue&type=template&id=9223d4b2&"
import script from "./classRight.vue?vue&type=script&lang=js&"
export * from "./classRight.vue?vue&type=script&lang=js&"
import style0 from "./classRight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports